<script>
import { mapGetters } from "vuex";
import TableRow from "./TablaRow.vue";

export default {
  components: { TableRow },
  computed: { ...mapGetters(["isMaster", "getResultados", "showConectores"]) },
};
</script>

<template>
  <div v-if="isMaster" class="panel panel-default">
    <table class="table table-hover">
      <thead>
        <tr>
          <th></th>
          <th v-if="showConectores">Proveedor</th>
          <th v-if="showConectores">Operador</th>
          <th v-html="'C&oacute;digo'"></th>
          <th>Nombre</th>
          <th width="115">Tarifa</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <table-row
          v-for="resultado in getResultados"
          :key="resultado.codigo"
          :resultado="resultado"
        ></table-row>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.panel {
  border: 0;
  transition-property: box-shadow, opacity;
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: box-shadow;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

  > .table {
    > thead {
      > tr {
        > th {
          color: #fff;
          background-color: #343a40;
          border-color: #454d55;
        }
      }
    }
  }
}
</style>